import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-failure-template',
  templateUrl: './payment-failure-template.component.html',
  styleUrls: ['./payment-failure-template.component.scss']
})
export class PaymentFailureTemplateComponent implements OnInit {

  @Input() rowOne = {
    failureLogo: null,
    failureMsg: null,
    failureInfoMsg: null
  };

  @Input() rowTwo = [
    { rowName: null, rowValue: null },
    { rowName: null, rowValue: null },
    { rowName: null, rowValue: null },
  ];

  @Input() templateButtonText: string = 'TRY AGAIN';
  @Input() showTemplateButton: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }
}
